import Validation from "@irati/utils/validation"

export const poNumberSchema = Validation.string("platform.defaultValidation.required").max(255)
